export interface NamedOption<T = string> {
  value: T;
}

export function getCurrentOption<
TCurrentValue extends string = string,
TOption extends NamedOption<TCurrentValue> = NamedOption<TCurrentValue>,
>(current: TCurrentValue, options: TOption[]): {
  option: TOption;
  index: number;
} {
  const index = options.findIndex((value) => value.value === current);
  return {
    option: options[index] as TOption,
    index,
  };
}

export function getNextOption<
TCurrentValue extends string = string,
TOption extends NamedOption<TCurrentValue> = NamedOption<TCurrentValue>,
>(
  current: TCurrentValue,
  options: TOption[],
): TOption {
  const { index: currentOptionIdx } = getCurrentOption(current, options);
  let nextOption: TOption | undefined = options[0];
  if (currentOptionIdx < options.length) {
    nextOption = options[(currentOptionIdx + 1) % (options.length)];
  }
  return nextOption as TOption;
}
